import './link_to_show_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['jsButton', 'nojsButton']
  static classes = ['hide']

  connect = (): void => {
    if (this.layover) {
      this.nojsButtonTarget.classList.add(this.hideClass)
    } else {
      this.jsButtonTarget.classList.add(this.hideClass)
    }
  }

  open = (): void => {
    this.layoverController().load(this.nodeId, 'show')
  }

  layoverController = (node: object): object => {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
  }

  get nodeId (): string {
    return this.element.dataset.nodeId
  }

  get layover (): boolean {
    return document.getElementById('layover') !== null
  }
}
